<template>
    <div id="page-index">
        <div class="panel">
            <div class="panel-head">
                <h2>Pages</h2>
                <ul class="actions">
                    <li><a @click.prevent="showPageCreate = true" class="action" href="#">Add Page</a></li>
                </ul>
            </div>
            <div class="panel-body">
                <p v-if="pages.length == 0"><em>No additional pages currently added.</em></p>
                <table v-else>
                    <thead>
                        <tr>
                            <th>Status</th>
                            <th>URL</th>
                            <th>Added On</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="page in pages">
                            <td><i class="fa" :class="{ 'fa-times red': page.is_down, 'fa-check green': !page.is_down}"></i></td>
                            <td><a target="_blank" :href="root + page.path">{{ page.path }}</a></td>
                            <td>{{ page.created_at | moment('YYYY-MM-DD') }}</td>
                            <td><a @click.prevent="deletePage(page.id)" href="#"><i class="fa fa-trash"></i></a></td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <page-create :show="showPageCreate" @update="loadPages()" @close="showPageCreate = false"></page-create>
    </div>
</template>

<script>
import PageCreate from '@/components/pinger/pages/PageCreate'

export default {
    name: 'PageIndex',
    props: [ 'root' ],
    components: {
        PageCreate
    },
    data() {
        return {
            pages: [],
            showPageCreate: false
        }
    },
    async created() {
        await this.loadPages()
    },
    methods: {
        async loadPages() {
            let response = await this.$http.get('/pingers/' + this.$route.params.id + '/pages')
            this.pages = response.data
        },
        async deletePage(pageId) {
            if(window.confirm('Are you sure you want to delete this page?')) {
                let response = await this.$http.delete('/pingers/' + this.$route.params.id + '/pages/' + pageId)
                this.loadPages()
            }
        }
    }
}
</script>

<style lang="scss">
#page-index {
    td:first-of-type,
    th:first-of-type {
        text-align: center;
    }
}
</style>
